﻿import {Injectable} from 'ng-metadata/core';


@Injectable()
export class OrganizationsService {


    constructor(){

    }

}





// WEBPACK FOOTER //
// ./src/main/webapp/components/journals/organizations/organizations.service.ts